// extracted by css-extract-rspack-plugin
export default {"updateConfig":"ImkycpadykkckzLj","message":"sYOGD5yNJwe1UwnY","messageHeading":"xzc4B1sIWUHP1G9k","messageParagraph":"_jyb31EsPAFrCxpL"};